'use client';
import React from 'react';
import Typography from '@ui/Typography';
import ProfileEditButton from '@components/ProfileEditButton';
import { formatNumberForLocale } from '@utils/stringHelpers';
import Link from 'next/link';
import ContactInformation from '@components/ContactInformation';
import Image from 'next/image';
import useCheckBreakpointActive from '@/hooks/useBreakpoint';
import { useBreakpointHooks } from '@/utils/break-points.provider';
import { isEmpty } from 'lodash-es';
import { getJobTitle } from '@/utils/user.helper';

const getDisplayAddress = (city, state, country) => {
  try {
    const location = [city, state, country].filter((item) => !!item);
    if (location.length > 0) {
      return location.join(', ');
    } else {
      return country;
    }
  } catch (e) {
    return country;
  }
};

function ProfileTitle(props) {
  const { userProfile, currentUser } = props;
  const city = userProfile && userProfile.location?.city;
  const state = userProfile && userProfile.location?.state;
  const country = userProfile && userProfile.location?.country;
  const [contactInfoOpen, setContactInfoOpen] = React.useState(false);

  const isContactVisible = () => {
    return !!(
      userProfile.facebookProfile?.trim().length > 0 ||
      userProfile.linkedin_profile?.trim().length > 0 ||
      userProfile.twitterProfile?.trim().length > 0 ||
      userProfile.instagramProfile?.trim().length > 0
    );
  };

  let slug = userProfile?.profileUrl;
  if (!userProfile?.profileUrl || userProfile.profileUrl.length === 0) {
    slug = `${userProfile?.first_name?.toLowerCase()}-${userProfile?.last_name?.toLowerCase()}-${
      userProfile.id
    }`;
  }

  // const extraSmall = useCheckBreakpointActive('xs', 'down');
  const isExtraSmallScreen = useBreakpointHooks((bp) => bp.useSmaller('sm'));

  return (
    <div>
      <div className="flex flex-row items-center gap-3.5">
        <Typography variant="h2" component="h2">
          {userProfile && userProfile.fullName}
        </Typography>
        {/* <span>
          <ProfileEditButton userProfile={userProfile} />
        </span> */}
      </div>

      <Typography variant="h4">
        {/* {userProfile && userProfile.designation}{' '}
        {userProfile?.companyName && 'at'}{' '}
        {userProfile && <Link href="#">{userProfile.companyName}</Link>} */}
        {getJobTitle(userProfile)}
      </Typography>
      <div
        className={`flex flex-row items-center ${
          userProfile.locationDetails ? 'gap-2.5 divide-x' : ''
        }`}>
        {currentUser ? (
          <>
            <Typography variant="h4" color="textSecondary">
              {/* {getDisplayAddress(city, state, country)} */}
              {userProfile.locationDetails}
            </Typography>
            {isContactVisible() && (
              <Typography
                // variant="hyperlink"
                variant="subtitle1"
                color="hyperlink"
                className={`cursor-pointer ${
                  userProfile.locationDetails ? 'pl-2.5 pr-2.5' : ''
                }`}
                onClick={() => setContactInfoOpen(!contactInfoOpen)}>
                Contact Info.
              </Typography>
            )}
          </>
        ) : (
          <>
            {userProfile.profileVisible && userProfile.locationVisible && (
              <Typography variant="h4" color="textSecondary">
                {/* {getDisplayAddress(city, state, country)} */}
                {userProfile.locationDetails}
              </Typography>
            )}
            {userProfile.profileVisible &&
              userProfile.contactInformationVisible &&
              isContactVisible() && (
                <Typography
                  // variant="hyperlink"
                  variant="subtitle1"
                  color="hyperlink"
                  className={`cursor-pointer ${
                    userProfile.locationDetails ? 'pl-2.5 pr-2.5' : ''
                  }`}
                  onClick={() => setContactInfoOpen(!contactInfoOpen)}>
                  Contact Info.
                </Typography>
              )}
          </>
        )}
      </div>

      <div className={`mt-1 flex ${isExtraSmallScreen ? 'flex-col' : ''}`}>
        {userProfile.numFollowers > 0 && (
          <Typography
            variant="hyperlink"
            color="hyperlink"
            className="cursor-pointer !text-18">
            {userProfile && formatNumberForLocale(userProfile.numFollowers)}{' '}
            Followers
          </Typography>
        )}

        {slug && (
          <div
            className={`flex ${
              isExtraSmallScreen || userProfile.numFollowers === 0
                ? ''
                : 'ml-8 justify-center'
            }`}>
            <Image
              height={20}
              width={20}
              className="cursor-pointer object-cover"
              src="/assets/images/neki-heart.png"
              alt="profile-url"
            />
            <Typography
              variant="hyperlink"
              color="hyperlink"
              // onClick={() => handleNavigate(slug)}
              className={`${
                isExtraSmallScreen ? 'ml-1' : 'ml-2'
              } cursor-pointer !text-18`}>
              {slug}
            </Typography>
          </div>
        )}
      </div>
      {contactInfoOpen && (
        <ContactInformation
          isPublic={true}
          userProfile={userProfile}
          handleClose={(value) => setContactInfoOpen(value)}
        />
      )}
    </div>
  );
}

export default ProfileTitle;
